import { Box, Typography } from "@mui/material";

interface EvidenceListProps {
  items: string[];
  bulletColor: string;
}

const EvidenceList = ({ items, bulletColor }: EvidenceListProps) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
    {items.map((item, idx) => (
      <Box
        key={idx}
        sx={{
          fontSize: "12px",
          color: "#6b7280",
          fontStyle: "italic",
          display: "flex",
          alignItems: "flex-start",
          gap: 0.75
        }}
      >
        <Typography
          component="span"
          sx={{ color: bulletColor, fontSize: "12px" }}
        >
          {"•"}
        </Typography>
        <Typography component="span" sx={{ fontSize: "12px", color: "inherit" }}>
          {item}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default EvidenceList;
